import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Play } from "lucide-react";

const SRC = "/elite-leads-reel-v2.mp4";
const POSTER = "/elite-leads-reel-poster-v2.jpg";

export const AdReel = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="ad-reel-play-btn"
        className={`group relative block overflow-hidden rounded-xl border border-white/15 bg-black shadow-lg ${className}`}>
        <img src={POSTER} alt="Elite Leads reel" className="h-full w-full object-cover object-[50%_12%] opacity-90 transition-opacity duration-300 group-hover:opacity-100" data-testid="ad-reel-thumbnail" />
        <span className="absolute bottom-3 right-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-400 text-slate-900 shadow-xl transition-transform duration-300 group-hover:scale-110">
            <Play className="ml-1 h-6 w-6 fill-current" />
          </span>
        </span>
        <span className="absolute bottom-2 left-3 text-xs font-bold uppercase tracking-wider text-white drop-shadow">Watch the Elite Leads reel</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm border-0 bg-black p-0 sm:max-w-md" data-testid="ad-reel-dialog">
          <DialogTitle className="sr-only">Elite Leads ad reel</DialogTitle>
          {open && <video src={SRC} poster={POSTER} controls autoPlay playsInline className="max-h-[85vh] w-full rounded-lg object-contain" data-testid="ad-reel-video" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
